import React, { Component } from 'react';
import { Card, Modal } from "react-bootstrap";
import { FaPen, FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from "react-icons/fa6";
import { GetText, ReplacePrefixUrl, ReplaceText, ReplaceTextBr2Space } from '../../config/helper';
import DateTimeFormats from '../../config/date-time-format';
// import PromptForm from './Form';
// import PromptDetail from './Detail';
// import NAimage from '../../img/pic-na.png';

const authKey = global.config.kindcode.training[22]+global.config.authBearerKey;

export default class DiscussionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      activePage: '',
      threadList: undefined,
      // id: '',
      // title: '',
      // category: '',
      // excerpt: '',
      // reply: 0,
      // createbyid: '',
      // createby: '',
      // createon: '',
      // data: {},
      // modal_show_form: false,
      // modal_show_detail: false,
      // memberStatus: localStorage.getItem('status')
    }
    this.loadContent = this.loadContent.bind(this);
  }
  handleOpenPage(url) {
    window.location.href=url;
  }
  loadContent(contents) {
    var threadList = [];
    console.log("contents")
    console.log(contents);
    if(contents.length > 0) {
      contents.sort((c,d) => d.content.lastUpdate._seconds - c.content.lastUpdate._seconds)
      .slice(0, 2)
      .map((threadItem, j) => {
        console.log(threadItem);
        // var libraryEnrolledSend = libraryEnrolled.subcontent;
        // libraryEnrolledSend.id = libraryEnrolled.subdocid;
        threadList.push(<tr key={threadItem.docid} className='text-link' onClick={this.handleOpenPage.bind(this,global.config.urlHost+"/"+this.state.activePage+"/discussion/"+threadItem.docid)}>
            <td>{threadItem.content.threadTitle}</td>
            <td className='text-center'>0</td>
        </tr>)
      })
      // contents.sort((a, b) => a.content.memberName > b.content.memberName);
    } else {
      threadList.push(<tr key="1">
          <th scope="row"></th>
            <td></td>
            <td className="d-flex p-3">- no data -</td>
            <td></td>
        </tr>)
    }
    return threadList;
  }
  componentDidMount() {
    var content = this.props.value;
    console.log("list")
    console.log(content);
    this.setState({
      activePage: content.activePage,
      threadList: content.data,
      // id: content.id,
      // image: (content.libraryPicture !== "" && content.libraryPicture !== undefined)? content.libraryPicture : NAimage,
      // title: ReplaceText(content.promptSubject),
      // category: content.promptCategoryName,
      // excerpt: ReplaceTextBr2Space(content.promptDescription),
      // reply: 0,
      // createbyid: content.createById,
      // createby: content.createByName,
      // createon: content.createDate !== undefined? DateTimeFormats(content.createDate._seconds,"datetime-short") : '',
      // link: '/library/' + ReplacePrefixUrl(content.libraryTitle) + '/' + content.id
      // link: '/library/' + ReplaceAllContent(" ", "-", content.libraryTitle).replace(/[^0-9a-zA-Z-]/g, '').substring(0,50) + '/' + content.id
      // link: (this.state.memberStatus === 'Member' ? '/enroll/' : '/library/') + content.id,
      // data: content,
    });
  }
  
  render() {   
    return (
      <div className="discussion-list">
				<table className="table table-rounded ">
          <thead>
            <tr key="0">
              <th scope="col">{GetText() ? "Topik" : "Topic"}</th>
              <th width="100" scope="col" className='text-center'>{GetText() ? "Balasan" : "Replies"}</th>
            </tr>
          </thead>
          <tbody>
              {this.state.threadList !== undefined && this.loadContent(this.state.threadList)}
          </tbody>
        </table>
       
			</div>
      
      
    )
  }
}